import { render, staticRenderFns } from "./wtStoryDuration.vue?vue&type=template&id=7618786a&scoped=true&"
import script from "./wtStoryDuration.vue?vue&type=script&lang=js&"
export * from "./wtStoryDuration.vue?vue&type=script&lang=js&"
import style0 from "./wtStoryDuration.vue?vue&type=style&index=0&id=7618786a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7618786a",
  null
  
)

export default component.exports